/**
    Given a DOM element, returns its background color by walking up the
    ancestor chain until a non-transparent background is found. Falls back
    to "rgb(255, 255, 255)" (white) if every ancestor is transparent.
    @param elem The DOM element to check.
*/ export default function(elem) {
    var node = elem;
    while(node){
        var bg = getComputedStyle(node).backgroundColor;
        if (bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)") return bg;
        node = node.parentElement;
    }
    return "rgb(255, 255, 255)";
}

//# sourceMappingURL=backgroundColor.js.map